<template lang="pug" src="./template.pug">
</template>
<style scoped lang="scss" src="./style.scss"></style>

<script>
import utils from "utils/js/utils";
import bus from "utils/js/bus";
export default {
  name: "Download",
  props: {
    msg: String,
  },
  mounted() {
    utils.startLoading(".download", () => {
      bus.$emit("showLoading", false);
    });
  },
};
</script>
